import GroupActionTypes from 'redux/groups/types';

const initialState = {
  groups: [],
  groupItems: [],
  loading: false,
  error: null,
  saving: null,
  savingGroup: false,
  savingGroupItem: false,
  errorSaving: null,
};

function groupsReducer(state = initialState, { type, payload }) {
  switch (type) {
    case GroupActionTypes.START_FETCH_GROUPS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GroupActionTypes.FETCH_GROUPS_SUCCESS:
      return {
        ...state,
        loading: false,
        groups: payload,
      };
    case GroupActionTypes.FETCH_GROUPS_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case GroupActionTypes.START_FETCH_GROUP_ITEMS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GroupActionTypes.FETCH_GROUP_ITEMS_SUCCESS:
      return {
        ...state,
        loading: false,
        groupItems: payload,
      };
    case GroupActionTypes.FETCH_GROUP_ITEMS_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case GroupActionTypes.ADD_GROUP_ITEM:
      return {
        ...state,
        savingGroupItem: true,
      };
    case GroupActionTypes.ADD_GROUP_ITEM_SUCCESS:
      return {
        ...state,
        savingGroupItem: false,
        groupItems: [payload, ...state.groupItems],
      };
    case GroupActionTypes.ADD_GROUP_ITEM_FAILURE:
      return {
        ...state,
        savingGroupItem: false,
        error: payload,
      };
    case GroupActionTypes.UPDATE_GROUP:
      return {
        ...state,
        savingGroup: true,
        errorSaving: false,
      };
    case GroupActionTypes.UPDATE_GROUP_FAILURE:
      return {
        ...state,
        savingGroup: false,
        errorSaving: true,
      };
    case GroupActionTypes.UPDATE_GROUP_SUCCESS:
      return {
        ...state,
        savingGroup: false,
        errorSaving: false,
        groups: state.groups.map((g) => {
          if (g.value === payload.id)
            return { value: payload.id, label: payload.name };
          return g;
        }),
      };
    case GroupActionTypes.UPDATE_GROUP_ITEM:
      return {
        ...state,
        savingGroupItem: true,
        errorSaving: false,
      };
    case GroupActionTypes.UPDATE_GROUP_ITEM_FAILURE:
      return {
        ...state,
        savingGroupItem: false,
        errorSaving: true,
      };
    case GroupActionTypes.UPDATE_GROUP_ITEM_SUCCESS:
      return {
        ...state,
        savingGroupItem: false,
        errorSaving: false,
        groupItems: state.groupItems.map((g) => {
          if (g.id === payload.id) return payload;
          return g;
        }),
      };
    case GroupActionTypes.ADD_GROUP:
      return {
        ...state,
        savingGroup: true,
      };
    case GroupActionTypes.ADD_GROUP_SUCCESS:
      return {
        ...state,
        savingGroup: false,
        groups: [payload, ...state.groups],
      };
    case GroupActionTypes.ADD_GROUP_FAILURE:
      return {
        ...state,
        savingGroup: false,
        error: payload,
      };
    case GroupActionTypes.DELETE_GROUP:
      return {
        ...state,
        loading: true,
      };
    case GroupActionTypes.DELETE_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
        groups: state.groups.filter((g) => g.value !== payload),
      };
    case GroupActionTypes.DELETE_GROUP_ITEM_SUCCESS:
      return {
        ...state,
        loading: false,
        groupItems: state.groupItems.filter((item) => item.id !== payload),
      };
    default:
      return state;
  }
}

export default groupsReducer;
